import { CheckCircle, Info } from '@phosphor-icons/react';

export function Toast({ message, type = 'success' }: { message: string; type?: 'success' | 'info' }) {
  return <div className="toast" role="status">{type === 'success' ? <CheckCircle size={19} weight="fill" /> : <Info size={19} weight="fill" />}<span>{message}</span></div>;
}
